import { apiClient } from '@lib/httpClient/apiClient';
import {
  type IListMedicalSpecialtiesEndpointQuery,
  type IListMedicalSpecialtiesEndpointResponse,
  listMedicalSpecialtiesEndpoint,
} from '@lib/httpClient/endpoints/medicalSpecialties/listMedicalSpecialtiesEndpoint';

import type { IListMedicalSpecialtiesInputDTO } from './dtos/list/IInputData';
import type { IListMedicalSpecialtiesOutputDTO } from './dtos/list/IOutputData';
import { type IMedicalSpecialtyRepository } from './IMedicalSpecialtyRepository';

class MedicalSpecialtyService implements IMedicalSpecialtyRepository {
  public async list(
    inputData: IListMedicalSpecialtiesInputDTO,
  ): Promise<IListMedicalSpecialtiesOutputDTO> {
    const response = await apiClient.get<
      IListMedicalSpecialtiesEndpointResponse,
      IListMedicalSpecialtiesEndpointQuery
    >({
      path: listMedicalSpecialtiesEndpoint(),
      params: {
        treatment_category_id: inputData.treatmentCategoryId,
      },
    });
    const output: IListMedicalSpecialtiesOutputDTO = {
      list: response.list.map((item) => ({
        id: item.id,
        sku: item.sku,
        title: item.title,
      })),
    };
    return output;
  }
}

export const medicalSpecialtyService = new MedicalSpecialtyService();
